import ShortCutKey from '../../interaction/shortcutkey/index';
import Storage from '../../storage/index';
import History from '../../interaction/history/index';

function init(): void {
    ShortCutKey.on({
        keyName: 'command+z',
        callback: (event) => {
            History.stackOut();
        }
    });

    ShortCutKey.on({
        keyName: 'ctrl+z',
        callback: (event) => {
            History.stackOut();
        }
    });
}

export default {
    init
};
